// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useLocation, useHistory, Redirect} from 'react-router-dom';
// @ts-ignore
import {renderRoutes, matchRoutes} from 'react-router-config';
import cn from 'classnames';
import www_util from 'hola_pub_util';
// @ts-ignore
import {Provider} from '../../../hola/pub/context.js';
import {Settings_context, Settings_provider}
    from '../../../hola/pub/settings_ctx';
import {Data_provider} from '../../../hola/pub/data_ctx';
import {Meta} from '../../../hola/pub/meta';
import {use_qs} from '../../../hola/pub/lib/use_qs';
import {Allow_cookies} from '../../../hola/pub/ui/allow_cookies';
import {Client_hints_provider} from '../../../hola/pub/client_hints';
import {Cookie_consent} from '../../../hola/pub/ui/cookie_consent';
import {Navbar_toolip} from '../ui/navbar/navbar';
import '../../../../www/hola/pub/css/components.less';
import './app.less';
import {Toolip_footer} from '../ui/footer/footer';
import {toolip_img_url} from '../../../hola/pub/ui/toolip_img_url';
import {Intercom} from '../../../hola/pub/ui/intercom';
import {www_hola} from 'hola_opt';
import toolip_theme
    from '../../../../www/hola/pub/css/core/toolip_theme.module.less';
import {Ga} from '../ui/ga';
// @ts-ignore
import cookie from 'cookie';
// @ts-ignore
import {fetch} from '/util/fetch.js';
import {use_persist_debug_param} from '../../../hola/pub/lib/debug';
import {AppContextProvider} from '../lib/app_context';
import {Gradient_hero, HP_global, Gradient_hero_editor,
    HP_global_editor} from './toolip.io/free-proxy';
import {Products_cards, Products_cards_editor} from '../ui/free_proxy/product_cards';
import {HP_final, HP_final_editor} from '../ui/homepage/hp_final';
import {HP_feature_slides, HP_feature_slides_editor} from '../ui/homepage/hp_feature_slides';
import {Top_locations} from '../ui/location/top_locations';
import etask from 'zetask';
import {get_aliased_pathname, get_pathname_for_redirect}
    from '../../../hola/pub/lib/use_pathname';
import {Html, Html_editor} from '../../../hola/pub/lib/html';
import {Vs_hero, Vs_hero_editor} from '../ui/vs_toolip/vs_hero';
import {Feature_cards, Feature_cards_editor} from '../ui/vs_toolip/feature_cards';
import {Comparison_table, Comparison_table_editor} from '../ui/vs_toolip/comparison_table';
import {HP_cards} from '../ui/hp_cards';
import {Cta_section, Cta_section_editor} from '../ui/vs_toolip/cta_section';
import {Review_slides, Review_slides_editor} from '../ui/landings/review_slides';
import {Vs_faq, Vs_faq_editor} from '../ui/vs_toolip/vs_faq';
import {General_faq, General_faq_editor} from '../ui/vs_toolip/general_faq';
import {All_cases_page, All_cases_page_editor} from '../ui/use_cases/all_cases_page';
import {Use_case_hero, Use_case_hero_editor} from '../ui/use_cases/use_case_hero';
import {Why_proxy, Why_proxy_editor, Why_proxy_v2, Why_proxy_v2_editor}
    from '../ui/landings/why_proxy';
import {Ad_card, Ad_card_editor} from '../ui/use_cases/ad_card';
import {Use_case_faq, Use_case_faq_editor} from '../ui/use_cases/use_case_faq';
import {Other_products, Other_products_editor} from '../ui/toolip/other_products';
import {Use_case_bubbles, Use_case_bubbles_editor} from '../ui/use_case_bubbles';
import {Product_hero, Product_hero_editor} from '../ui/toolip/product_hero';
import {Pricing_widget, Pricing_widget_editor} from '../ui/pricing_widget';
import {Bubbles, Bubbles_editor} from '../ui/toolip/bubbles';
import Icon_x from '../img/icons/16/close.svg';
import {type i_toast_config, Toast_container,
  Toast_provider} from '../../../shared/ui/toast';
import {Pricing_lobby, Pricing_lobby_editor} from '../ui/pricing/pricing_lobby';
import {Editor} from '../../../shared/editor/editor';
import {Benefits, Benefits_editor} from '../ui/benefits/benefit';
import {Integrations_hero, Integrations_hero_editor} from '../ui/integrations_hero/integrations_hero';
import {Case_card, Case_card_editor} from '../ui/case_card';
import {HP_gradient_hero, HP_gradient_hero_editor} from '../ui/homepage/hp_gradient_hero';
import {Cms_switcher} from '../ui/toolip/cms_switcher';
import {Location_hero} from '../ui/location/hero';
import {use_previous} from '../../../hola/pub/lib/use_previous';

const toast_config: i_toast_config = {
    close_icon: <Icon_x/>,
};

const static_resolvers = {
    'Html': {
        tag: Html,
        editor: Html_editor,
        props: {
            html: `<h2>Title</h2><p>Text in p1</p>
              <p class="p2">Text in p.p2</p>
              <p class="p12 semi">Text with class p12 and semi</p>`,
        },
    },
    'Spacer': {
        tag: p=><div style={{height: p.height}}/>,
        editor: p=>{
            const [state, set_state] = useState(p.value);
            return <Editor
              value={state}
              editors={[{key: 'height', label: 'height', type: 'text'}]}
              on_change={v=>set_state(v)}
              on_save={()=>p.on_change(state)}
              on_cancel={p.on_cancel}/>;
        },
    },
    'Gradient_hero': {
        tag: Gradient_hero,
        editor: Gradient_hero_editor,
    },
    'HP_gradient_hero': {
        tag: HP_gradient_hero,
        editor: HP_gradient_hero_editor,
    },
    'Product_hero': {
        tag: Product_hero,
        editor: Product_hero_editor,
    },
    'HP_global': {
        tag: HP_global,
        editor: HP_global_editor,
    },
    'HP_final': {
        tag: HP_final,
        editor: HP_final_editor,
    },
    'Products_cards': {
        tag: Products_cards,
        editor: Products_cards_editor,
    },
    'HP_feature_slides': {
        tag: HP_feature_slides,
        editor: HP_feature_slides_editor,
    },
    'Location_hero': {
        tag: Location_hero,
    },
    'Top_locations': {
        tag: Top_locations,
    },
    'Vs_toolip_hero': {
        tag: Vs_hero,
        editor: Vs_hero_editor,
    },
    'Vs_feature_cards': {
        tag: Feature_cards,
        editor: Feature_cards_editor,
    },
    'Vs_comparison_table': {
        tag: Comparison_table,
        editor: Comparison_table_editor,
    },
    'HP_cards': {
        tag: HP_cards
    },
    'Vs_cta_section': {
        tag: Cta_section,
        editor: Cta_section_editor,
    },
    'Review_slides': {
        tag: Review_slides,
        editor: Review_slides_editor,
    },
    'Vs_faq': {
        tag: Vs_faq,
        editor: Vs_faq_editor,
    },
    'General_faq': {
        tag: General_faq,
        editor: General_faq_editor,
    },
    'All_cases_page': {
        tag: All_cases_page,
        editor: All_cases_page_editor,
    },
    'Use_case_hero': {
        tag: Use_case_hero,
        editor: Use_case_hero_editor,
    },
    'Why_proxy': {
        tag: Why_proxy,
        editor: Why_proxy_editor,
    },
    'Why_proxy_v2': {
        tag: Why_proxy_v2,
        editor: Why_proxy_v2_editor,
    },
    'Ad_cards': {
        tag: Ad_card,
        editor: Ad_card_editor,
    },
    'Use_case_faq': {
        tag: Use_case_faq,
        editor: Use_case_faq_editor,
    },
    'Other_products': {
        tag: Other_products,
        editor: Other_products_editor,
    },
    'Use_case_bubbles': {
        tag: Use_case_bubbles,
        editor: Use_case_bubbles_editor,
    },
    'Pricing_widget': {
        tag: Pricing_widget,
        editor: Pricing_widget_editor,
    },
    'Bubbles': {
        tag: Bubbles,
        editor: Bubbles_editor,
    },
    'Pricing_lobby': {
        tag: Pricing_lobby,
        editor: Pricing_lobby_editor,
    },
    'Integrations_hero': {
        tag: Integrations_hero,
        editor: Integrations_hero_editor,
    },
    'Benefits': {
        tag: Benefits,
        editor: Benefits_editor,
    },
    'Case_card': {
        tag: Case_card,
        editor: Case_card_editor,
    }
};

const themes = {
    default: toolip_theme,
    toolip_theme: toolip_theme,
};

const r_or_call = v=>{
    if (typeof v=='function')
        return v();
    return v;
};

const nav_opt = {
    img_url_fn: toolip_img_url,
    logo: 'toolip/logo_black.svg',
};
const route_opt = {
    with_cart: false,
    default_theme: 'toolip',
    cp_link: '/dashboard',
    cp_after_login: true,
    footless: false,
};

export const App = function App(props){
    const [client, set_client] = useState(false);
    const [cookie_ready, set_cookie_ready] = useState(false);
    const history = useHistory();
    if (window)
    {
        // XXX dmitriiz: dirty hack: we have to send it to a lot places in
        // code
        // @ts-ignore
        window.react_history = history;
    }
    const {pathname: current_pathname} = useLocation();
    const pathname = get_aliased_pathname(current_pathname);
    const prev_current_pathname = use_previous(current_pathname);
    const pn_redirect = get_pathname_for_redirect(location.pathname);
    const init_path = useRef(pathname);
    const is_ssr_page = useRef(true);
    const navigated = useRef(false);
    const top_portal_ref = useRef();
    const navbar_portal_ref = useRef();
    const footer_portal_ref = useRef();
    const {routes} = props.route;
    const matched: any[] = matchRoutes(routes, pathname) || [];
    const silent_state = useMemo(()=>{
        return {path: matched && matched[0] && matched[0].route.path};
    }, []);
    const [app_settings, set_app_settings] = useState({
        edit_mode: false,
        overrides: {...props.overrides},
        meta: {...props.meta_overrides},
        resolvers: static_resolvers,
        save_overrides: (pn, conf, just_state?)=>{
            set_app_settings(app_s=>({
                ...app_s,
                overrides: {
                    ...app_s.overrides,
                    [pn]: conf,
                },
            }));
            if (conf.loading || conf.error || just_state)
                return;
            fetch(`/cms/save_overrides?path=${
                encodeURIComponent(pn)
            }`, {
                method: 'POST',
                json: true,
                body: {
                    override: conf,
                },
            });
        },
        save_meta: (pn, conf, just_state?)=>{
            set_app_settings(app_s=>({
                ...app_s,
                meta: {
                    ...app_s.meta,
                    [pn]: conf,
                },
            }));
            if (conf.loading || conf.error || just_state)
                return;
            fetch(`/cms/save_meta?path=${
                encodeURIComponent(pn)
            }`, {
                method: 'POST',
                json: true,
                body: {
                    meta: conf,
                },
            });
        }
    });
    use_persist_debug_param();
    useEffect(()=>{
        if (props.user && cookie.get('need_unsubscibe'))
        {
            cookie.remove('need_unsubscibe', {domain: `.${location.host}`,
                path: '/'});
            fetch('/users/set_email_unsubscribe', {
                method: 'POST',
                body: {email: props.user.emails[0].value, value: true},
            });
        }
    }, []);
    useEffect(()=>{
        const path = matched && matched[0] && matched[0].route.path;
        if (navigated.current && history.action!='POP')
        {
            if (silent_state.path!=path)
            {
                // @ts-ignore
                window.scroll({top: 0, behavior: 'instant'});
            }
        }
        else
            navigated.current = true;
        silent_state.path = path;
    }, [pathname]);
    useEffect(()=>{
        if (app_settings.overrides[pathname]
        && (prev_current_pathname &&
        current_pathname === prev_current_pathname))
        {
            return;
        }
        app_settings.save_overrides(pathname, {loading: true}, true);
        etask(function*(){
            const lng = props.i18n_instance.language;
            const overrides = yield fetch(`/cms/get_overrides?path=${
                encodeURIComponent(pathname)
            }&lng=${lng}&reqp=${encodeURIComponent(current_pathname)}`);
            if (overrides && overrides.status=='ok')
            {
                props.i18n_instance.addResourceBundle(lng, 'translation',
                    overrides.translations[lng]?.translation || {});
                app_settings.save_overrides(pathname, overrides.overrides,
                    true);
                app_settings.save_meta(pathname, overrides.meta, true);
            }
            else
                app_settings.save_overrides(pathname, {error: true}, true);
        });
    }, [pathname, current_pathname, prev_current_pathname, app_settings]);
    useEffect(()=>{
        // @ts-ignore
        history.block(()=>www_util.before_spa());
        // @ts-ignore
        if (window.postponed_js)
        {
            setTimeout(()=>{
                // @ts-ignore
                window.postponed_js.forEach(js=>{
                    const s_el = document.createElement('script');
                    s_el.src = js;
                    // @ts-ignore
                    s_el.onerror = function(){ window.handle_fallback(this); };
                    document.head.appendChild(s_el);
                });
            }, 0);
        }
        set_client(true);
    }, []);
    const route_props = Object.assign({top_portal_ref, navbar_portal_ref,
        footer_portal_ref}, props);
    if (route_props.location)
        route_props.location = {...route_props.location, pathname: pathname};
    const [reload, set_reload] = useState(1);
    useEffect(()=>{
        if (matched[0].route && !matched[0].route.loaded)
        {
            matched[0].route.on_load = ()=>{
                set_reload(r=>r+1);
                matched[0].route.on_load = undefined;
            };
        }
    }, [matched[0].route && matched[0].route.loaded]);
    let headless = matched.every(({route})=>r_or_call(route.headless));
    let footless = matched.every(({route})=>r_or_call(route.footless));
    if (app_settings?.meta?.[pathname]?.headless !== undefined)
        headless = app_settings?.meta?.[pathname]?.headless;
    if (app_settings?.meta?.[pathname]?.footless !== undefined)
        footless = app_settings?.meta?.[pathname]?.footless;
    const qs = use_qs();
    const consent_test = qs.consent_test;
    const hide_allow_cookies = matched.every(({route})=>
        r_or_call(route.hide_allow_cookies)) || props.is_eu || consent_test;
    const {route} = matched && matched[0] || {};
    const overridden_meta = app_settings.meta?.[pathname] || {};
    const merged_route = {
        ...route,
        ...overridden_meta,
    };
    const _host = props.host && props.host.replace(/\./g, '_');
    const _page = pathname.slice(1).replace(/\//g, '_')||'homepage';
    const wrapper_cls = useMemo(()=>{
        if (is_ssr_page.current && pathname!==init_path.current)
            is_ssr_page.current = false;
        return cn(props.host && `host-${_host}`, `page-${_page}`,
            props.is_portal || qs.no_animation ? 'no-animation' : '', {
                client,
                portal: props.is_portal,
                ssr_page: is_ssr_page.current,
            });
    }, [props.host, _host, _page, props.is_portal, qs.no_animation, client]);
    useEffect(()=>{
        www_util.perr({id: `www_lang_${props.lang}_selected`});
        if (!route.click_tracking)
            return;
        const host = route.click_host || _host;
        const handle_click = event=>{
            const {id, info} = www_util.get_click_data(event.target);
            if (id)
            {
                const perr_id = `www_click_${host||'unknown_host'}_${id}`;
                www_util.perr({id: perr_id, info, build: {pathname}});
            }
        };
        document.addEventListener('click', handle_click);
        return ()=>document.removeEventListener('click', handle_click);
    }, [_page]);
    const def_keywords = 'proxy, proxies, free proxy pool, cheap, ISP, '+
        'datacenter proxies, API, residential proxy.';
    const def_description = 'Toolip.io - Get affordable premium proxies. '+
        'Enjoy high-speed, reliable, and secure proxy services tailored to '+
        'your needs. Free trial.';
    let switch_opt = {location: {...props.location}};
    switch_opt.location.pathname = pathname;
    if (pn_redirect)
        return <Redirect to={pn_redirect}/>;
    const toggle_edit_mode = ()=>{
        const location_region_regex = /^\/proxy-location\/[^/]+\/[^/]+$/;
        const location_only_regex = /^\/proxy-location\/[^/]+$/;
        if (location_region_regex.test(current_pathname))
        {
            history.push('/proxy-location/:location/:region');
            set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
            return;
        }
        if (location_only_regex.test(current_pathname))
        {
            history.push('/proxy-location/:location');
            set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
            return;
        }
        set_app_settings(prev=>({...prev, edit_mode: !prev.edit_mode}));
    };
    return <Data_provider {...props} route={route}>
      <Provider {...props} headless={headless} is_client_debug={qs.preview}>
        <Settings_provider {...props} location={window.location} route={route}
          app_default_theme={'toolip'} themes_add={themes}
          app_settings={app_settings} set_app_settings={set_app_settings}>
          <Meta props={props} routes={routes} matched={matched}
            def_keywords={def_keywords} def_description={def_description}
            overrided_meta={app_settings?.meta?.[pathname]}>
            <Client_hints_provider {...props}>
              <Toast_provider config={toast_config}>
                <AppContextProvider>
                  <Settings_context.Consumer>
                  {value=><div id={'page_content_wrapper'} key={reload}
                    className={cn(wrapper_cls, value.theme.root)}>
                    <Ga />
                    <Intercom with_intercom={www_hola.with_intercom}
                      app_id={'li91gtt6'} need_plus={false}/>
                    <Navbar_toolip {...props} route={route}
                      nav_opt={nav_opt} route_opt={route_opt}
                      nomenu no_getstarted is_toolip/>
                    {renderRoutes(routes, route_props, switch_opt)}
                    {!hide_allow_cookies && <Allow_cookies/>}
                    {!cookie_ready && (consent_test
                      || props.is_eu && !props.cookie_value) ?
                      <Cookie_consent is_toolip on_apply={()=>{
                        set_cookie_ready(true);
                      }} cookie_name={'allow_toolip_cookie'}/> : null}
                    {!footless && <Toolip_footer route={merged_route}/>}
                    <Toast_container/>
                    <Cms_switcher
                      caption={!app_settings.edit_mode ? 'Open CMS' :
                        'Close CMS'}
                      on_click={toggle_edit_mode}/>
                  </div>}
                  </Settings_context.Consumer>
                </AppContextProvider>
              </Toast_provider>
            </Client_hints_provider>
          </Meta>
        </Settings_provider>
      </Provider>
    </Data_provider>;
};
